import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import CheckoutButton from './CheckoutButton';

const RandomText = loadable(() => import('./RandomText'))
const OrderNote = loadable(() => import('./OrderNote'))

const ExtraModule = ({ moduleKey, modules, cartNote }) => {
	const { random_text, checkout_button, order_note } = modules;

	switch (moduleKey) {
		case 'random_text':
			return random_text.active ? <RandomText /> : null;
		case 'order_note':
			return order_note.active ? <OrderNote cartNote={cartNote} /> : null;
		case 'checkout_button':
			return <CheckoutButton />;

		default:
			return null;
	}
};

ExtraModule.propTypes = {};

export default ExtraModule;
